import ClickOutside from './directives/ClickOutside';
import Focus from './directives/Focus';
export default function (app) {
    ClickOutside(app);
    Focus(app);
}